import _ from 'lodash';
import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';

export const useGetClients = () =>
    useQuery({
        queryKey: ['support-clients'],

        queryFn: async () => {
            const response = await RQAPICallWithData<ClientT[]>({
                endpoint: `support/clients`,
                method: 'GET',
            });
            return _.sortBy(response.content.data, 'name');
        },
    });
